export default {
    'summary': {
        'text': `<div class="content-caption-box">
        <h3 class="content-caption">The Minto Pyramid Principle® App</h3>
      </div>
      <p class="content-text">
        You may also download an app that summarizes what Barbara teaches in her live course. Created as a quick reference for people
        who have already had the course, it also serves as an easy way for you quickly to find the concepts that are explained
        in the book.
      </p>
      <p class="content-text">
        It requires cellular data connect or wifi, and can be found on Apple iTunes Stores for $14.99. An Android version is also
        available from Googleplay.
      </p>
      <p class="content-text">
        Please note that the summary provides only an insight into the thinking behind the Minto Pyramid Principle; it does not actually
        teach how to apply it to your work. That, alas, takes deeper explanation and practice!
      </p>`,
    }
}


// WEBPACK FOOTER //
// ./client/app/modules/site/summary/i18n/es.js